export default "__VITE_ASSET__NA6OrvLn__"